import * as p5 from 'p5';
import {PlantHealth} from '../@utils/data.service';

export class Batami {

  private readonly _p: p5;
  private readonly _id: number;
  private readonly _health: PlantHealth;
  private readonly _modelAssets: BatamiModel;
  private readonly _others: Batami[];

  private _modelHolder;
  private _batTexture: p5.Image;

  private _bodyRadius: number = 200;
  private _pos: BatamiPos = new BatamiPos();

  constructor(p: p5, id: number, health: PlantHealth, model: BatamiModel, others: Batami[]) {
    this._p = p;
    this._id = id;
    this._health = health;
    this._modelAssets = model;
    this._others = others;
  }

  setup() {
    this._modelHolder = this._p.loadModel(this._modelAssets.model);
    this._batTexture = this._p.loadImage(this._modelAssets.material[this._health]);

    this._pos._dirVec = p5.Vector.random2D();
    this._pos._x = this._p.random(-269, 269);
    this._pos._z = this._p.random(-269, 269);

    while (this.isColliding()) {
      this._pos._x = this._p.random(-269, 269);
      this._pos._z = this._p.random(-269, 269);
    }

    this._pos._posVec = this._p.createVector(this._pos._x, this._pos._y, this._pos._z);
  }

  move() {
    this._pos._x = this._pos._posVec.x;
    this._pos._z = this._pos._posVec.z;

    if (this.isColliding()) {
      this._pos._dirVec.mult(-1);
    }

    this._pos._posVec.add(this._pos._dirVec.x, 0, this._pos._dirVec.y);
  }

  isColliding(): boolean {
    let ret: boolean = false;
    for (let i = this._id + 1; i < this._others.length; i++) {
      let dx = this._others[i]._pos._x - this._pos._x;
      let dz = this._others[i]._pos._z - this._pos._z;
      let distance = this._p.sqrt(dx * dx + dz * dz);
      let minDist = this._others[i]._bodyRadius / 2 + this._bodyRadius / 2;

      if (distance < minDist || this.checkBoundaries()) {
        ret = true;
      }
    }

    return ret;
  }

  checkBoundaries(): boolean {
    return this._pos._x >= 400 || this._pos._z >= 400 || this._pos._x <= -400 || this._pos._z <= -400
  }

  show() {
    this._p.push();
    this._p.translate(this._pos._x, this._pos._y, this._pos._z);
    this._p.rotateY(this._p.atan2(this._pos._posVec.x - this._pos._x, this._pos._posVec.z - this._pos._z));
    this._p.texture(this._batTexture);
    this._p.model(this._modelHolder);
    this._p.pop();
  }

}

class BatamiPos {

  _x: number;
  _y: number;
  _z: number;
  _rotation: number;
  _posVec: p5.Vector;
  _dirVec: p5.Vector;

  constructor(x: number = 0, y: number = 0, z: number = 0, rotation: number = 0,
              posVec: p5.Vector = p5.Vector.random2D(), dirVec: p5.Vector = p5.Vector.random2D()) {
    this._x = x;
    this._y = y;
    this._z = z;
    this._rotation = rotation;
    this._posVec = posVec;
    this._dirVec = dirVec
  }
}

export class BatamiModel {
  name: string;
  material: {
    good: string,
    wet: string,
    dry: string,
  };
  model: string;

  constructor(name: string, material: { good: string, wet: string, dry: string }, body: string) {
    this.name = name;
    this.material = material;
    this.model = body;
  }
}
